import config from '../../Config';
const c = config;

/**
 * Object that contains all dynamic css rules
 * 
 * value: valor inicial que adquiere por defecto.
 * index: Nombre (único) de regla.
 *  -> Naming: {property}-{key}
 * type: Propiedad css.
 * selectors: Array de clases afectadas por esta regla.
 * 
 * relatives: Cuando una regla es cambiada, también lo son
 *  sus 'relatives'. Dichos 'relatives' adquieren el mismo
 *  'value', pero son procesados por un filtro.
 */
const CSSRules = {
  // DIRECT VARIABLES
  header_text: {
    value: c.colors.header_text,
    rules: [
      {
        index: 'color_header-text',
        type: 'color',
        selectors: [
          '.hu-color_header-text',
        ],
      },
    ],
  },
  bot_message_background: {
    value: c.colors.bot_message_background,
    rules: [
      {
        index: 'background-color_bot-message-background',
        type: 'background-color',
        selectors: [
          '.hu-background-color_bot-message-background',
          '#hu-footer-input-mobile .hu-input-header',
          '.hu-message.brand .hu-message-info.visible + .hu-message-content::before',
        ],
      },
    ],
  },
  bot_message_text: {
    value: c.colors.bot_message_text,
    rules: [
      {
        index: 'color_bot-message-text',
        type: 'color',
        selectors: [
          '.hu-color_bot-message-text',
        ],
      },
    ],
  },
  user_message_background: {
    value: c.colors.user_message_background,
    rules: [
      {
        index: 'background-color_user-message-background',
        type: 'background-color',
        selectors: [
          '.hu-background-color_user-message-background',
        ],
      },
    ],
  },
  user_message_text: {
    value: c.colors.user_message_text,
    rules: [
      {
        index: 'color_user-message-text',
        type: 'color',
        selectors: [
          '.hu-color_user-message-text',
        ],
      },
    ],
  },
  button_background: {
    value: c.colors.button_background,
    rules: [
      {
        index: 'background-color_button-background',
        type: 'background-color',
        selectors: [
          '.hu-background-color_button-background',
          '.hu-header-btn-referral:hover, .hu-header-btn-referral:focus',
          '.multi-button.active',
          '#hu-message-input .left-arrow',
          '.open .keyword-switch',
          '#hu-footer-input-mobile .back-button',
          '#hu-footer-input-mobile .powered-by-text a',
          '#hu-footer-input-mobile .keyword-button',
          '#hu-footer-input-mobile .skip-pause-button',
        ],
      },
      {
        index: 'color_button-background',
        type: 'color',
        selectors: [
          '.hu-color_button-background',
          '.multi-button:hover:not(.active) .button-text',
        ],
      },
      {
        index: 'border-color_button-background',
        type: 'border-color',
        selectors: [
          '.multi-button:not(.active) .check-block',
          '.multi-button:not(.active) .check-label:after',
          '#hu-footer-input-mobile .multi-button',
        ],
      },
    ],
    relatives: [
      'button-background-dark',
      'button-background-light',
    ],
  },
  button_text: {
    value: c.colors.button_text,
    rules: [
      {
        index: 'color_button-text',
        type: 'color',
        selectors: [
          '.hu-color_button-text',
          '.multi-button.active .button-text',
          '#hu-footer-input-mobile .powered-by-text a',
          '#hu-footer-input-mobile .keyword-button',
        ],
      },
      {
        index: 'border-color_button-text',
        type: 'border-color',
        selectors: [
          '.hu-border-color_button-text',
          '.multi-button.active .check-block',
          '.multi-button.active .check-label:after',
        ],
      },
      {
        index: 'fill_button-text',
        type: 'fill',
        selectors: [
          '.hu-fill_button-text',
        ],
      },
    ],
  },
  textarea_background: {
    value: c.colors.textarea_background,
    rules: [
      {
        index: 'background-color_textarea-background',
        type: 'background-color',
        selectors: [
          '.hu-background-color_textarea-background',
        ],
      },
    ],
  },
  textarea_text: {
    value: c.colors.textarea_text,
    rules: [
      {
        index: 'color_textarea-text',
        type: 'color',
        selectors: [
          '.hu-color_textarea-text',
          '.hu-textarea-heavy .hu-textarea:empty:before',
          '#hu-footer-input-mobile .hu-textarea:empty:before',
        ],
      },
    ],
  },
  textarea_border: {
    value: c.colors.textarea_border,
    rules: [
      {
        index: 'border-color_textarea-border',
        type: 'border-color',
        selectors: [
          '.hu-border-color_textarea-border',
          '#hu-message-input .hu-textarea-heavy .hu-textarea-input-container.focus, #hu-footer-input-fixed .hu-textarea-heavy .hu-textarea-input-container.focus',
          '.hu-textarea-heavy .hu-textarea',
        ],
      },
      {
        index: 'fill_textarea-text',
        type: 'fill',
        selectors: [
          '.hu-textarea-heavy .send svg',
        ],
      },
    ],
  },
  inline_input: {
    value: c.colors.inline_input,
    rules: [
      {
        index: 'color_inline-input',
        type: 'color',
        selectors: [
          '.hu-color_inline-input',
          '.hu-textarea-light .hu-textarea',
          '.hu-textarea-light .hu-textarea:empty:before',

          // '.hu-textarea-light .hu-textarea::-webkit-input-placeholder',
          // '.hu-textarea-light .hu-textarea::-moz-placeholder',
          // '.hu-textarea-light .hu-textarea:-ms-input-placeholder',
          // '.hu-textarea-light .hu-textarea:-moz-placeholder',
        ],
      },
      // START PLACEHOLDERS
      {
        index: 'color_inline-input_webkit-placeholder',
        type: 'color',
        selectors: ['.hu-textarea-light .hu-textarea::-webkit-input-placeholder']
      },
      {
        index: 'color_inline-input_webkit-placeholder',
        type: 'color',
        selectors: ['.hu-textarea-light .hu-textarea::-moz-placeholder']
      },
      {
        index: 'color_inline-input_webkit-placeholder',
        type: 'color',
        selectors: ['.hu-textarea-light .hu-textarea::-ms-input-placeholder']
      },
      {
        index: 'color_inline-input_webkit-placeholder',
        type: 'color',
        selectors: ['.hu-textarea-light .hu-textarea:-moz-placeholder']
      },
      // END PLACEHOLDERS
      {
        index: 'background-color_inline-input',
        type: 'background-color',
        selectors: [
          '.hu-background-color_inline-input',
        ],
      },
      {
        index: 'fill_inline-input',
        type: 'fill',
        selectors: [
          '.hu-fill_inline-input',
          '.hu-textarea-light .send',
        ],
      },
    ],
  },
  accent: {
    value: c.accent,
    rules: [
      {
        index: 'background-color_accent',
        type: 'background-color',
        selectors: [
          '.hu-background-color_accent',
          // '.hu-header-btn-referral:hover, .hu-header-btn-referral:focus',
          // '.multi-button.active',
          // '#hu-message-input .left-arrow',
          // '.open .keyword-switch',
          '#hu-bot-progress-bar::after'
        ],
      },
      {
        index: 'color-accent',
        type: 'color',
        selectors: [
          '.hu-color_accent',
          // '.hu-textarea-heavy .hu-textarea::-webkit-input-placeholder',
          // '.hu-textarea-heavy .hu-textarea::-moz-placeholder',
          // '.hu-textarea-heavy .hu-textarea:-ms-input-placeholder',
          // '.hu-textarea-heavy .hu-textarea:-moz-placeholder',
          // '.hu-textarea-heavy .hu-textarea:empty:before',
          // '.multi-button:hover:not(.active) .button-text',
          '#hu-footer-input-mobile .hu-input-multi-info',
          '#hu-footer-input-mobile .hu-input-menu-info',
          '#hu-footer-input-mobile .multi-button:not(.active) .button-text',
          // '#hu-footer-input-mobile .hu-textarea::-webkit-input-placeholder',
          // '#hu-footer-input-mobile .hu-textarea::-moz-placeholder',
          // '#hu-footer-input-mobile .hu-textarea:-ms-input-placeholder',
          // '#hu-footer-input-mobile .hu-textarea:-moz-placeholder',
          // '#hu-footer-input-mobile .hu-textarea:empty:before',
          '#hu-footer-input-mobile .drop-search-input-container i',
          '#hu-footer-input-mobile .drop-search-input',
        ],
      },
      {
        index: 'border-color_accent',
        type: 'border-color',
        selectors: [
          // '#hu-message-input .hu-textarea-heavy .hu-textarea-input-container.focus, #hu-footer-input-fixed .hu-textarea-heavy .hu-textarea-input-container.focus',
          // '.multi-button:not(.active) .check-block',
          // '.multi-button:not(.active) .check-label:after',
          // '#hu-footer-input-mobile .multi-button',
        ],
      },
      {
        index: 'fill_accent',
        type: 'fill',
        selectors: [
          '.hu-fill_accent',
          // '.hu-textarea-heavy .send svg',
          '#hu-footer-input-mobile .send svg, #hu-footer-input-mobile .attach svg, #hu-footer-input-mobile .emoji svg',
        ],
      },
      {
        index: 'stroke_accent',
        type: 'stroke',
        selectors: [
          '.hu-stroke_accent',
        ],
      },
      {
        index: 'border-bottom_accent',
        type: 'border-bottom',
        selectors: [
          '#hu-footer-input-mobile .drop-search-input-container',
        ],
      },
    ],
    relatives: [
      'accent-light',
      'accent-dark',
    ],
  },
  dark: {
    value: c.dark,
    rules: [
      {
        index: 'background-color_dark',
        type: 'background-color',
        selectors: [],
      },
      {
        index: 'color_dark',
        type: 'color',
        selectors: [
          '.hu-color_dark',
          '.multi-button:not(.active) .button-text',
        ],
      },
      {
        index: 'border-color_dark',
        type: 'border-color',
        selectors: [],
      },
    ],
  },
  light: {
    value: c.light,
    rules: [
      {
        index: 'background-color_light',
        type: 'background-color',
        selectors: [
          '.hu-background-color_light',
          '.sk-folding-cube .sk-cube::before',
          '.multi-button:not(.active)',
        ],
      },
      {
        index: 'color_light',
        type: 'color',
        selectors: [
          '.hu-color_light',
          // '.multi-button.active .button-text',
          '.hu-keyword-selector.open .keyword-switch',
        ],
      },
      {
        index: 'border-color_light',
        type: 'border-color',
        selectors: [
          '.hu-border-color_light',
          // '#hu-message-input .dual .menu-button:not(.icon):not(.image):last-child:not(:hover)',
          '#hu-message-input .dual .menu-button:not(.image):last-child:not(:hover)',
          // '.multi-button.active .check-block',
          // '.multi-button.active .check-label:after',
          // '.multi-button:not(.active)',
        ],
      },
      {
        index: 'fill_light',
        type: 'fill',
        selectors: [
          '.hu-fill_light',
        ],
      },
    ],
  },
  contrast: {
    value: c.contrast,
    rules: [
      {
        index: 'background-color_contrast',
        type: 'background-color',
        selectors: [
          '.hu-background-color_contrast',
        ],
      },
      {
        index: 'color_contrast',
        type: 'color',
        selectors: [
          '.hu-color_contrast',
          // '.hu-textarea-light .hu-textarea::-webkit-input-placeholder',
          // '.hu-textarea-light .hu-textarea::-moz-placeholder',
          // '.hu-textarea-light .hu-textarea:-ms-input-placeholder',
          // '.hu-textarea-light .hu-textarea:-moz-placeholder',
          // '.hu-textarea-light .hu-textarea:empty:before',
          '#hu-message-input .hu-input-multi-info',
          // '.hu-message-bubble.typing::before',
          '#hu-footer .hu-keyword-selector::before',
        ],
      },
      {
        index: 'border-color_contrast',
        type: 'border-color',
        selectors: [
          '.hu-border-color_contrast',
        ],
      },
      {
        index: 'fill_contrast',
        type: 'fill',
        selectors: [
          '.hu-fill_contrast',
          // '.hu-textarea-light .send',
        ],
      },
      {
        index: 'stroke_contrast',
        type: 'stroke',
        selectors: [
          '.hu-stroke_contrast',
        ],
      },
    ],
    relatives: [
      'contrast-fade',
      'contrast-fade-0.7',
    ],
  },
  header_background: {
    value: c.header_background,
    rules: [
      {
        index: 'background-color_header-background',
        type: 'background-color',
        selectors: [
          '.hu-background-color_header-background',
        ],
      },
    ],
  },
  avatar_scale: {
    value: `scale(${c.avatar_scale})`,
    rules: [
      {
        index: 'transform_avatar-scale',
        type: 'transform',
        selectors: [
          '.hu-message-avatar::before',
        ],
      },
    ],
  },
  avatar_url: {
    value: c.avatar_url ? `url("${c.avatar_url}")` : `url("https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png")`,
    rules: [
      {
        index: 'background-image_logo',
        type: 'background-image',
        selectors: [
          '.hu-message-avatar:before',
        ],
      },
    ],
  },
  font: {
    value: c.font ? `${c.font},sans-serif` : 'Montserrat,sans-serif',
    rules: [
      {
        index: 'font-family_font',
        type: 'font-family',
        selectors: [
          '#app-landbot, button, input, textarea',
        ],
      },
    ],
  },
  font_size: {
    value: c.font_size ? `${c.font_size}px` : '13px',
    rules: [
      {
        index: 'font-size_font-size',
        type: 'font-size',
        selectors: [
          '#app-landbot, button, input, textarea',
        ],
      },
    ],
  },
  // logo: {
  //   value: c.logo ? `url("${c.logo}")` : `url("https://storage.googleapis.com/media.helloumi.com/brands/helloumi.png")`,
  //   rules: [
  //     {
  //       index: 'background-image_logo',
  //       type: 'background-image',
  //       selectors: [
  //         '.hu-message-avatar:before',
  //       ],
  //     },
  //   ],
  // },
  background_color: {
    value: c.background_color,
    rules: [
      {
        index: 'background-color_background-color',
        type: 'background-color',
        selectors: [
          '#hu-background .hu-background-color',
        ],
      },
    ],
  },
  background_gradient: {
    value: `linear-gradient(to bottom, ${c.gradient_from} 0%, ${c.gradient_to} 100%)` || 'linear-gradient(to bottom, #FFAD59 0%, #FFE199 100%)',
    rules: [
      {
        index: 'background_background-gradient',
        type: 'background',
        selectors: [
          '#hu-background .hu-background-gradient',
        ],
      },
    ],
  },
  background_image_url: {
    value: `url("${c.background_image_url}")` || 'url("https://storage.googleapis.com/media.yexir.com/channels_back/31.png")',
    rules: [
      {
        index: 'background-image_background-image-url',
        type: 'background-image',
        selectors: [
          '#hu-background .hu-background-image',
        ],
      },
    ],
  },
  background_video_fallback: { // TODO: Esto necesita un repaso
    value: c.video_url ? `url("https://storage.googleapis.com/static.helloumi.com/landbot/video/${c.video_url}.jpg")` : 'url("https://storage.googleapis.com/static.helloumi.com/landbot/video/video_1.jpg")',
    rules: [
      {
        index: 'background-image_background_video_fallback',
        type: 'background-image',
        selectors: [
          '#hu-background .hu-background-video video',
        ],
      },
    ],
  },
  filter_color: {
    value: c.filter_color,
    rules: [
      {
        index: 'background_filter-color',
        type: 'background-color',
        selectors: [
          '#hu-filter .hu-filter-color',
        ],
      },
    ],
  },
  filter_gradient: {
    value: (c.filter_gradient_from && c.filter_gradient_to) ? `linear-gradient(to bottom, ${c.filter_gradient_from} 0%, ${c.filter_gradient_to} 100%)` : 'linear-gradient(to bottom, #FFAD59 0%, #FFE199 100%)',
    rules: [
      {
        index: 'background_filter-gradient',
        type: 'background',
        selectors: [
          '#hu-filter .hu-filter-gradient',
        ],
      },
    ],
  },
  filter_image_url: {
    value: c.filter_image_url ? `url("${c.filter_image_url}")` : 'url("https://storage.googleapis.com/media.yexir.com/channels_back/31.png")',
    rules: [
      {
        index: 'background-image_filter-image-url',
        type: 'background-image',
        selectors: [
          '#hu-filter .hu-filter-image',
        ],
      },
    ],
  },


  // RELATIVE VARIABLES
  'button-background-dark': {
    tasks: [
      {
        filter: 'lightenDarkenColor',
        factor: -.5,
      },
    ],
    rules: [
      {
        index: 'border-color_button-background-dark',
        type: 'border-color',
        selectors: [
          '.hu-border-color_button-background-dark',
          '#hu-message-input .dual .menu-button:last-child:hover',
          '.multi-button.active',
        ],
      },
    ],
  },
  'button-background-light': {
    tasks: [
      {
        filter: 'lightenDarkenColor',
        factor: 0.3, // 0.3?
      }
    ],
    rules: [
      {
        index: 'background-color_button-background-light',
        type: 'background-color',
        selectors: [
          '.hu-background-color_button-background-light',
          '.hu-background-color_button-background-light_hover:hover',
          '#hu-message-input .hu-input-box .hu-input-menu .hu-input-menu-buttons .menu-button:hover',
          '.hu-input-multi .submit-button:hover:not(:disabled)',
          '#hu-message-input .left-arrow:hover',
          '.multi-button.active:hover',
          '.p-menu-button:hover',
        ],
      },
    ],
  },
  'accent-light': {
    // value: '#F23164', // F7205D?
    tasks: [
      {
        filter: 'lightenDarkenColor',
        factor: 0.3, // 0.3?
      },
    ],
    rules: [
      {
        index: 'background-color_accent-light',
        type: 'background-color',
        selectors: [
          '.hu-background-color_accent-light',
          '.hu-background-color_accent-light_hover:hover',
          // '#hu-message-input .hu-input-box .hu-input-menu .hu-input-menu-buttons .menu-button:hover',
          // '.hu-input-multi .submit-button:hover:not(:disabled)',
          // '#hu-message-input .left-arrow:hover',
          // '.multi-button.active:hover',
        ],
      },
    ],
  },
  'accent-dark': {
    // value: '#000000',//'#CB0C3F',
    tasks: [
      {
        filter: 'lightenDarkenColor',
        factor: -.5,
      },
    ],
    rules: [
      {
        index: 'border-color_accent-dark',
        type: 'border-color',
        selectors: [
          '.hu-border-color_accent-dark',
          // '#hu-message-input .dual .menu-button:last-child:hover',
          // '.multi-button.active',
        ],
      },
    ],
  },
  'contrast-fade': {
    // value: 'rgba(255, 255, 255, .4)',
    tasks: [
      {
        filter: 'fadeColor',
        factor: 0.4,
      },
    ],
    rules: [
      {
        index: 'border-color_contrast-fade',
        type: 'border-color',
        selectors: [
          '.hu-border-color_contrast-fade',
        ],
      },
      {
        index: 'background-color_contrast-fade',
        type: 'background-color',
        selectors: [
          '.hu-background-color_contrast-fade',
        ],
      },
    ],
  },
  'contrast-fade-0.7': {
    tasks: [
      {
        filter: 'fadeColor',
        factor: 0.7,
      },
    ],
    rules: [
      {
        index: 'border-color_contrast-fade-07',
        type: 'border-color',
        selectors: [
          '.hu-border-color_contrast-fade-07',
        ],
      },
    ],
  },
};

export default CSSRules;


// WEBPACK FOOTER //
// ./app/js/components/dynamic-styles/CSSRules.js